import type { AppFeatureDefinition } from "@nasam/kernel";
import { createPartsAndInventoryRoutes } from "./presentation/routes";

const INVENTORY_VIEW =
  "parts_and_inventory.inventory_management.inventory_management_list.view";

export const partsAndInventoryFeature: AppFeatureDefinition = {
  id: "parts-and-inventory",
  version: "0.1.0",
  titleKey: "common:businessModules.partsAndInventory",
  icon: "Box",
  basePath: "/inventory",
  requiredPermissions: [INVENTORY_VIEW],
  navigation: [
    {
      id: "parts-and-inventory",
      titleKey: "common:businessModules.partsAndInventory",
      icon: "Box",
      placement: "rail",
      order: 60,
      children: [
        {
          id: "inventory-list",
          titleKey: "partsAndInventory:nav.inventory",
          placement: "drawer",
          order: 10,
          path: "/inventory",
          requiredPermissions: [INVENTORY_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createPartsAndInventoryRoutes({ context }),
  i18n: {
    namespace: "partsAndInventory",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "parts_and_inventory",
      labelKey: "partsAndInventory:permissions.partsAndInventory",
      children: [
        {
          segment: "inventory_management",
          labelKey: "partsAndInventory:permissions.inventoryManagement",
          children: [
            {
              segment: "inventory_management_list",
              labelKey: "partsAndInventory:permissions.inventory",
              actions: [
                { id: "view", labelKey: "partsAndInventory:actions.view" },
                { id: "create", labelKey: "partsAndInventory:actions.create" },
                { id: "update", labelKey: "partsAndInventory:actions.update" },
                { id: "delete", labelKey: "partsAndInventory:actions.delete" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
